<template>
  <div>
    vue2 test components
  </div>
</template>

<script>
export default {
  name: 'TicTest'
}
</script>